import Vue from 'vue';
import StepperStepWrapper from '@/components/common/wrappers/StepperStepWrapper';
import DialogWrapper from '@/components/common/wrappers/DialogWrapper';


Vue.component('foe-stepper-step', StepperStepWrapper);
Vue.component('foe-dialog', DialogWrapper);

